import * as React from 'react'
import {Lang} from 'yougile-lang'
import {UIUtil, Util} from 'yougile-util'
import {ClientUtilities} from '../app/client/client-utilities'
import {FileUploadProgress} from '../app/components/file-upload-progress'
import {MessageBox} from '../app/components/message-box'

let fileInput: HTMLInputElement | null = null
let fileInputSingle: HTMLInputElement | null = null

const getInput = (multiple: boolean): HTMLInputElement => {
  const storage = multiple ? fileInput : fileInputSingle
  if (storage) {
    return storage
  }

  const el = document.createElement('input')
  el.type = 'file'
  el.name = '_filesToUpload'
  el.multiple = multiple
  el.style.opacity = '0'
  el.style.visibility = 'hidden'
  document.body.appendChild(el)

  if (multiple) {
    fileInput = el
  } else {
    fileInputSingle = el
  }

  return el
}

export class FileChooser {
  /**
   * @param e - added to ensure browser security
   * will not prevent the file dialog to appear,
   * this event must triggered by user.
   */
  public static chooseFile(
    e: {preventDefault?: () => void},
    multiple: boolean,
    callback?: (f: File) => void,
    accept?: string
  ): Promise<File> {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    return new Promise<File>(resolve => {
      const input = getInput(multiple)
      input.value = ''
      input.accept = accept || ''
      input.click()
      input.onchange = () => {
        for (const file of Util.iter(input.files)) {
          ClientUtilities.setDefaultName(file)
          if (callback) {
            callback(file)
          }
          resolve(file)
        }
      }
    })
  }

  public static uploadImage(
    event: React.MouseEvent | MouseEvent
  ): Promise<{url: string}> {
    return new Promise<{url: string}>((ok, fail) => {
      void FileChooser.chooseFile(event, false, (file: File) => {
        if (!UIUtil.isSupportedImage(file)) {
          MessageBox.warn(Lang.msg.imageTypeUnsupported)
          return
        }
        const id = Util.UUID()
        FileUploadProgress.addFile(id, file)
        void ClientUtilities.saveFile(
          {file},
          (url: string) => {
            FileUploadProgress.removeFile(id)
            if (!url) {
              fail()
              return
            }
            ok({url})
          },
          (progress: number) => {
            FileUploadProgress.updateProgress(id, progress)
          }
        )
      })
    })
  }

  public static async readFile(file: File): Promise<string> {
    return new Promise((ok, fail) => {
      const fr = new FileReader()
      fr.readAsText(file, 'utf-8')
      fr.onload = () => ok(fr.result + '')
      fr.onerror = () => fail(fr.error)
    })
  }
}
